import React from "react";
import GridPlayMain from "../puzzles/grid/GridPlayMain";

/**
 * Hidden-message grid play under `/story/play-grid/hidden_message/:id` (same UX as puzzle route).
 */
export default function StoryHiddenMessagePlay() {
    return <GridPlayMain gridPlayRouteTypeSegment="hidden_message" storyPlayLayout />;
}
